import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchLogin } from '../../redux/slices/loginSlice';

const LoginComponent = () => {
    const dispatch = useDispatch();

    const handleLogin = async (formData) => {
        try {
            const login = await dispatch(fetchLogin({
                userName: formData.mail,
                password: formData.password
            }));

            if (login.payload) {
                const data = login.payload;
                if (data.statusCode === 200 && data.result.isAdmin === 1) {
                    localStorage.setItem('auth', JSON.stringify(data.result));
                    toast.success(`${data.message}. Hoşgeldin, ${data.result.user.firstName}`);
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1500);
                } else {
                    toast.error(`${data.message}`);
                }
            }
        } catch (error) {
            toast.error('Giriş işlemi sırasında bir hata oluştu');
        }
    };

    return handleLogin;
};

export default LoginComponent;